import React from 'react';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@hqo/ui-atoms';
import { Spinner } from 'app/components/ui/spinner';
import { CheckIcon } from 'lucide-react';

export interface UserDialogButton {
  title: string;
  variant?: 'default' | 'secondary';
  isLoading?: boolean;
  handler: VoidFunction;
}

export interface CustomSizes {
  width?: string;
  height?: string;
  paddings?: Array<string>;
}

export interface Props {
  isVisible: boolean;
  title: string;
  description?: string;
  buttons: Array<UserDialogButton>;
  customSizes?: CustomSizes;
  onClose: VoidFunction;
  errorMessage?: string;
  isConfirmation?: boolean;
}

export const DesktopUserDialogModal: React.FC<Props> = ({ isVisible, title, description, buttons, onClose, errorMessage, isConfirmation }) => (
  <Dialog open={isVisible} onOpenChange={onClose}>
    {/* max-h + overflow: at large text sizes (e.g. a tablet with a big system font) the
        centred dialog would otherwise grow past both viewport edges and hide its actions. */}
    <DialogContent className="sm:max-w-[500px] p-7 border-none max-h-[90vh] supports-[height:100dvh]:max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <DialogHeader className="flex justify-start text-left w-full pb-1">
        <DialogTitle className="flex gap-2 items-center font-semibold text-xl leading-6 text-system-black">
          {isConfirmation && (
            <div className="flex justify-center items-center">
              <CheckIcon strokeWidth={3} className="w-8 h-8 text-system-green bg-system-green-light rounded-full p-2" />
            </div>
          )}
          {title}
        </DialogTitle>
      </DialogHeader>
      <DialogDescription className="font-normal text-md leading-6 text-system-grey-dark">
        {description && <span>{description}</span>}
      </DialogDescription>
      <div className="flex flex-col gap-2">
        <DialogFooter>
          {buttons.map(({ title: buttonTitle, handler, variant, isLoading }) => (
            <Button
              key={buttonTitle}
              disabled={isLoading}
              onClick={handler}
              variant={variant || 'default'}
              className={`h-12 text-md min-w-[100px] ${
            variant === 'secondary'
              ? 'bg-white border border-gray-600 text-gray-600 hover:bg-gray-100'
              : 'bg-primary border border-primary text-white hover:bg-primary focus:outline-primary active:outline-primary'
          }`}
            >
              {isLoading ? <Spinner size="small" /> : buttonTitle}

            </Button>
          ))}
        </DialogFooter>
        {errorMessage && <p className="flex justify-end text-system-pink text-[14px] mt-1 mb-[-10px]">{errorMessage}</p>}
      </div>
    </DialogContent>
  </Dialog>
  );
